import logoCATT from '../objects/LogoCattnuovo.png';
import logoEURO from '../objects/EN_FundedbytheEU_RGB_POS.png';


function Footer() {
    return (
        <footer>
            <hr className="mt-5 mb-4"/>
            <p className="text-muted">
                The MOLOR project was funded by the European Union as part of its Horizon Europe scientific research
                initiative under the Marie Skłodowska-Curie Actions (MSCA), grant agreement no. 101106220.
            </p>
            <div className="" >
                <img className="mx-auto" src={logoCATT} alt="logo" height={70}/>
                <img className="mx-auto" src={logoEURO} alt="logoEURO" height={70} />
            </div>
        </footer>
    )
}

export default Footer;